// My Rouhi — Theme JS

// Quick Add to Cart
document.addEventListener('click', function(e) {
  if (e.target.classList.contains('quick-add')) {
    const productId = e.target.dataset.productId;
    if (!productId) return;

    e.target.textContent = 'Adding...';
    e.target.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: productId, quantity: 1 })
    })
    .then(res => res.json())
    .then(() => {
      e.target.textContent = 'Added!';
      // Update cart count
      return fetch('/cart.js');
    })
    .then(res => res.json())
    .then(cart => {
      const countEl = document.querySelector('.cart-count');
      if (countEl) countEl.textContent = cart.item_count;
      setTimeout(() => {
        e.target.textContent = 'Quick Add';
        e.target.disabled = false;
      }, 1500);
    })
    .catch(() => {
      e.target.textContent = 'Quick Add';
      e.target.disabled = false;
    });
  }
});
